import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../reducers/Login';

export const useSessionHandler = () => {
  const [showSessionExpiredModal, setShowSessionExpiredModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    // Listener para evento customizado de sessão expirada
    const handleSessionExpired = () => {
      dispatch(logout());
      setShowSessionExpiredModal(true);
    };

    window.addEventListener('sessionExpired', handleSessionExpired);

    return () => {
      window.removeEventListener('sessionExpired', handleSessionExpired);
    };
  }, [dispatch]);

  const handleRedirectToLogin = () => {
    const canalTarifarioUrl = process.env.REACT_APP_CANAL_TARIFARIO_URL || 'https://www.copel.com';
    window.location.href = canalTarifarioUrl;
  };

  return {
    showSessionExpiredModal,
    handleRedirectToLogin,
  };
};